import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInvoice$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInvoice extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '742a6c867eb1705537494380edfd1df434e6b45d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '491e306fc10db267312926a2783892cb2f7b9220', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1fa088bf532a715bb632a782c6911257f931acd2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18 18.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h7.91a.5.5 0 0 1 .36.15l4.08 4.07a.47.47 0 0 1 .15.35zm-1.5-1V8h-3a.5.5 0 0 1-.5-.5v-3H6.5v13zM8 15a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm.5-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-invoice", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-invoice"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-invoice":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInvoice$1);
            }
            break;
    } });
}

const CosmosIconInvoice = CosmosIconInvoice$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInvoice, defineCustomElement };
